import * as React from 'react';
import { ArrowOut16 } from '@cian/ui-kit';
import { Link } from '../Link';
import * as styles from './SpecialPromoLink.css';

export interface ISpecialPromoLinkProps {
  url: string;
  label: string;
  logoUrl?: string | null;
  trackSpecialPromoClick?(): void;
}

export const SpecialPromoLink: React.StatelessComponent<ISpecialPromoLinkProps> = (props: ISpecialPromoLinkProps) => {
  const { url, label, logoUrl, trackSpecialPromoClick } = props;

  return (
    <Link url={url} target="blank" onClick={trackSpecialPromoClick} linkStyle={styles['link']}>
      {logoUrl && <img className={styles['logo']} src={logoUrl} />}
      <span className={styles['label']}>{label}</span>
      <ArrowOut16 color={'primary_100'} />
    </Link>
  );
};
